import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionSECrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE EVALUACIONES DE INVESTIGACIÓN SOCIOECONÓMICA Y/O PATRIMONIAL";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit } = useForm();

  const mutateFechaSE = useMutationData({
    url: `/fecha-socioeconomica/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-socioeconomica"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            // Aseguramos que los valores seleccionados se incluyan
            const formData = {
              ...data,
            };

            // Mutación para guardar la Fecha de Detección de Riesgos
            mutateFechaSE.mutate(
              {
                data: { fecha_autorizacionse: data.fecha_autorizacionse },
                tipo: "post",
              },
              {
                onSuccess: () => {
                  navigate(`/socioeconomica/${evaluadosList_id}`);
                  window.scrollTo(0, 0);
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Autorización Socioeconómica:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario} />

          {/* Contenido del formulario */}
          <div className="p-6">
            <div className={`text-center mb-8 ${isDarkMode ? "text-white" : "text-black"}`}>
              <div className="flex justify-center items-center gap-2 mb-4">
                <p className={`mt-3 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>Ciudad de México a</p>
                <Controller
                  name="fecha_autorizacionse"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="fecha_autorizacionse"
                      type="date"
                      {...field}
                      className={`text-center w-full z-10 ${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
                    />
                  )}
                />
              </div>
              <h2 className={`text-xl font-bold mb-4 flex items-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE EVALUACIONES DE
                INVESTIGACIÓN SOCIOECONÓMICA Y/O PATRIMONIAL
              </h2>
            </div>

            <div className="space-y-6">
              <div className={`flex items-start ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <span className="mr-2">Yo</span>
                <TextInput
                  type="text"
                  name="name"
                  value={`${queryEvaluado.data?.nombre || ""} ${
                    queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
                  onChange={handleInputChange}
                  className={`flex-1 mx-2 ${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
                />
                <span className="ml-2">
                  , autorizo que me aplique todas las evaluaciones de
                  Investigación Socioeconómicas
                </span>
              </div>
              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>y/o Patrimoniales, que consisten en</p>
              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <strong>VERIFICACIÓN Y ANÁLISIS DOCUMENTAL:</strong> Entrega de
                documentos necesarios para la conformación del expediente; así
                como la validación de documentos.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <strong>INVESTIGACIÓN ANTECEDENTES:</strong> Verificación de
                antecedentes registrales de tipo penal, administrativo, laboral,
                patrimonial, económico y de referencias; mediante la utilización
                de dinerosos sistemas, fuentes abiertas, públicas y oficiales, así
                como, la consulta en bases estatales y federales, y la
                investigación específica ante instituciones competentes que puedan
                proporcionar información de los antecedentes referidos. En su caso
                grabado de voz, toma de fotografía y huellas decadactilares.
              </p>
              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <strong>INVESTIGACIÓN SOCIOECONÓMICA:</strong> Llenado de
                cuestionarios, entrevistas si el caso lo amerita para indagar
                sobre el ambiente social, familiar, nivel de vida, trayectoria
                académica, laboral, profesional y visita domiciliaria.
              </p>
              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
                C.V. para que proporcione toda la información y documentación que
                derive de las evaluaciones de pruebas de confianza que me
                realicen.
              </p>
              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                En este acto autorizo y conozco el aviso de privacidad el cual se
                encuentra publicado en
                https://skyangel.com.mx/avisodeprivacidad.htlm, por lo cual en
                este acto consiento que SKA TRACKING AND SECURITY S.A. de C.V.
                podrá recabar mis datos personales de conformidad con los términos
                establecidos en dicho aviso.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                Bajo protesta de decir verdad hago constar que los datos
                proporcionados en el proceso de evaluación son verdaderos.
              </p>

              <div className={`mt-12 text-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                <p className="mb-8 font-bold">ATENTAMENTE</p>
                <div className={`w-64 mx-auto border-t pt-2 ${isDarkMode ? "border-gray-400" : "border-black"}`}>
                  <p className="text-sm">NOMBRE Y FIRMA</p>
                </div>
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`${isDarkMode ? "bg-red-600 hover:bg-red-700" : "bg-red-500 hover:bg-red-600 text-white"}`}
              >
                Regresar
              </Button>
              <button
                type="submit"
                className={`rounded px-4 py-2 z-10 transition-colors ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};